module.exports = __webpack_public_path__ + "static/media/service-scenario-bg6.69e40a29.png";